let svgSerial = 0

const BLINK_IDS = new Set(['eyes'])
const BODY_IDS = new Set(['body', 'curtain'])

export function svgFromRaw(raw: string, className: string): SVGSVGElement {
  const parsed = new DOMParser().parseFromString(raw, 'image/svg+xml')
  const root = parsed.documentElement
  if (root.namespaceURI !== 'http://www.w3.org/2000/svg' || root.localName !== 'svg') {
    throw new Error('Invalid SVG markup')
  }
  const svg = document.importNode(root, true) as unknown as SVGSVGElement
  svgSerial += 1
  svg.classList.add(className, 'art-svg')
  svg.setAttribute('aria-hidden', 'true')
  svg.setAttribute('focusable', 'false')
  svg.removeAttribute('width')
  svg.removeAttribute('height')
  svg.style.setProperty('--blink-delay', `${(svgSerial % 7) * 0.45}s`)

  for (const node of svg.querySelectorAll('[id]')) {
    const id = node.getAttribute('id')
    if (!id) continue
    if (BLINK_IDS.has(id)) {
      node.removeAttribute('id')
      node.classList.add('art-eyes')
      continue
    }
    if (BODY_IDS.has(id)) {
      node.removeAttribute('id')
      node.classList.add(id === 'curtain' ? 'art-curtain' : 'art-body')
    }
  }
  return svg
}

/** Tight viewBox around painted paths. Used on home tiles in portrait only. */
export function bindPortraitContentViewBox(svg: SVGSVGElement): void {
  const original = svg.getAttribute('viewBox')
  if (!original) return
  const cropped = croppedContentViewBox(svg)
  if (!cropped) return
  const mq = window.matchMedia('(orientation: portrait)')
  const apply = () => {
    svg.setAttribute('viewBox', mq.matches ? cropped : original)
  }
  apply()
  mq.addEventListener('change', apply)
}

function croppedContentViewBox(svg: SVGSVGElement): string | null {
  if (!document.body) return null
  const probe = svg.cloneNode(true) as SVGSVGElement
  probe.removeAttribute('class')
  probe.style.cssText =
    'position:fixed;left:0;top:0;width:400px;height:400px;opacity:0;pointer-events:none'
  document.body.append(probe)
  let box: DOMRect
  try {
    box = probe.getBBox()
  } catch {
    probe.remove()
    return null
  }
  probe.remove()
  if (box.width < 1 || box.height < 1) return null
  const pad = Math.max(box.width, box.height) * 0.01
  return `${box.x - pad} ${box.y - pad} ${box.width + pad * 2} ${box.height + pad * 2}`
}
